import OkC from "shared/util/OkcApi";

export const checkIsValidVoucher = ({ voucher, platform }) => {
	return OkC.post("/billingws/voucher/redeem", {
		data: {
			voucher_id: voucher,
			platform,
		},
	});
};



// WEBPACK FOOTER //
// ./src/shared/components/VoucherModal/web.js